import orderBy from 'lodash/orderBy';
import { INoticePc } from '../../pc/common/components/js/notice/Notice';
import { INoticeSp } from '../../sp/common/components/js/notice/Notice';

export default class NoticeHelper {
  /**
   * PCお知らせの並び替えを行う
   * タイプは,通常→メディアの並び順
   * 通常お知らせは以下にソートした順に表示する
   * 1. 掲載日時（降順）
   * 2. contentId（昇順）
   *
   * メディアタグお知らせは以下にソートした1件目のみを表示する
   * 1. 表示優先度（降順）
   * 2. 掲載日時（降順）
   *
   * @see https://wiki.workers-hub.com/pages/viewpage.action?pageId=1422541135
   * @param notices
   */
  public static sortNoticePC(notices: INoticePc[]): INoticePc[] {
    const filteredAnnounceNotices = notices.filter(notice => notice.type === 'announce');
    const announceNotices = orderBy(
      filteredAnnounceNotices,
      ['startTime', notice => orderBy(notice.contents, 'contentId', 'asc')?.[0]?.contentId],
      ['desc', 'asc']
    );

    const filteredMediaTagNotices = notices.filter(notice => notice.type === 'mediatag');
    const mediaTagNotice = orderBy(filteredMediaTagNotices, ['priority', 'startTime'], ['desc', 'desc'])?.[0];

    if (mediaTagNotice) {
      // contentsを先頭1個に絞る
      const contents = [orderBy(mediaTagNotice.contents, 'contentId', 'asc')[0]].filter(content => !!content);
      const singleContentsMediaTagNotice: INoticePc = {
        ...mediaTagNotice,
        contents
      };
      return [...announceNotices, singleContentsMediaTagNotice];
    } else {
      return announceNotices;
    }
  }
  /**
   * SPお知らせの並び替えを行う
   * タイプは,メインカラム中段はメディア→通常、それ以外は通常→メディアの並び順
   * 通常お知らせ内,メディアタグ内でのソートは,PC版と同じ
   *
   * @see https://wiki.workers-hub.com/pages/viewpage.action?pageId=1422541135
   * @param notices
   * @param onTopMediaTagNotice
   */
  public static sortNoticeSP(notices: INoticeSp[], onTopMediaTagNotice: boolean): INoticeSp[] {
    const filteredAnnounceNotices = notices.filter(notice => notice.type === 'announce');
    const announceNotices = orderBy(
      filteredAnnounceNotices,
      ['startTime', notice => orderBy(notice.contents, 'contentId', 'asc')?.[0]?.contentId],
      ['desc', 'asc']
    );

    const filteredMediaTagNotices = notices.filter(notice => notice.type === 'mediatag');
    const mediaTagNotice = orderBy(filteredMediaTagNotices, ['priority', 'startTime'], ['desc', 'desc'])?.[0];

    if (mediaTagNotice?.contents[0]) {
      // contentsをIDが小さい先頭1個に絞る
      const contents = [orderBy(mediaTagNotice.contents, 'contentId', 'asc')[0]].filter(content => !!content);
      const singleContentsMediaTagNotice = {
        ...mediaTagNotice,
        contents
      };

      if (onTopMediaTagNotice) {
        return [singleContentsMediaTagNotice, ...announceNotices];
      } else {
        return [...announceNotices, singleContentsMediaTagNotice];
      }
    } else {
      return announceNotices;
    }
  }
  /**
   * PCお知らせのposを追加
   *
   * @param notices
   */
  public static addPosNoticePC(notices: INoticePc[]): INoticePc[] {
    let announcePos = 0;
    let mediaTagPos = 0;
    return notices.map(notice => {
      return {
        ...notice,
        contents: notice.contents.map(content => {
          // お知らせにURLが含まれる場合のみposを付与
          if (!content.linkUrl) {
            return { ...content };
          } else {
            // 通常お知らせとメディアタグ連携お知らせで
            if (notice.type === 'announce') {
              return {
                ...content,
                pos: ++announcePos
              };
            } else {
              return {
                ...content,
                pos: ++mediaTagPos
              };
            }
          }
        })
      };
    });
  }
  /**
   * SPお知らせのposを追加
   *
   * @param notices
   */
  public static addPosNoticeSP(notices: INoticeSp[]): INoticeSp[] {
    let announcePos = 0;
    let mediaTagPos = 0;
    return notices.map(notice => {
      return {
        ...notice,
        contents: notice?.contents.map(content => {
          // お知らせにURLが含まれる場合のみposを付与
          if (!content.linkUrl) {
            return { ...content };
          } else {
            // 通常お知らせとメディアタグ連携お知らせで
            if (notice.type === 'announce') {
              return {
                ...content,
                pos: ++announcePos
              };
            } else {
              return {
                ...content,
                pos: ++mediaTagPos
              };
            }
          }
        })
      };
    });
  }
}
